import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Coins, Star, Gem } from "lucide-react";
import Mascot from "./Mascot";
import Confetti from "./Confetti";
import SquishyButton from "./SquishyButton";
import { sound } from "../lib/sounds";

// Big celebration modal shown after finishing a lesson.
export const RewardModal = ({ open, stars = 3, coins = 0, diamonds = 0, message, onClose, onReplay }) => {
  useEffect(() => {
    if (open) sound.reward();
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="reward-modal"
          className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        >
          <Confetti show={open} count={60} />
          <motion.div
            initial={{ scale: 0.7, y: 40 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 18 }}
            className="w-full max-w-sm rounded-[2rem] bg-white p-6 text-center shadow-2xl"
          >
            <Mascot mood="celebrate" message={message || "Goed gedaan!"} size={120} />
            <h2 className="mt-2 font-display text-3xl font-bold text-slate-800">Super!</h2>

            <div className="my-4 flex justify-center gap-2">
              {[0, 1, 2].map((i) => (
                <motion.div
                  key={i}
                  initial={{ scale: 0, rotate: -30 }}
                  animate={{ scale: i < stars ? 1 : 0.7, rotate: 0 }}
                  transition={{ delay: 0.2 + i * 0.15, type: "spring" }}
                >
                  <Star className="h-12 w-12" fill={i < stars ? "#FDE047" : "#E2E8F0"}
                        color={i < stars ? "#EAB308" : "#CBD5E1"} />
                </motion.div>
              ))}
            </div>

            <div className="mb-5 flex justify-center gap-4 font-display font-bold text-slate-700">
              <span className="flex items-center gap-1"><Coins className="h-5 w-5 text-yellow-500" />+{coins}</span>
              {diamonds > 0 && <span className="flex items-center gap-1"><Gem className="h-5 w-5 text-sky-400" />+{diamonds}</span>}
            </div>

            <div className="flex flex-col gap-3">
              <SquishyButton data-testid="reward-continue-btn" onClick={onClose} color="#4ADE80" edge="#16A34A" className="w-full text-lg">
                Verder spelen
              </SquishyButton>
              {onReplay && (
                <SquishyButton data-testid="reward-replay-btn" onClick={onReplay} color="#38BDF8" edge="#0284C7" className="w-full">
                  Nog een keer
                </SquishyButton>
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default RewardModal;
